document.addEventListener("click", function (e) {
  if (!e.target.classList.contains("delivery-check-btn")) return;

  const wrapper = e.target.closest(".delivery-checker");
  const pinInput = wrapper.querySelector(".delivery-pincode");
  const resultBox = wrapper.querySelector(".delivery-result");
  const resultText = wrapper.querySelector(".delivery-text");

  const pin = pinInput.value.trim();
  const pincodes = wrapper.dataset.pincodes.split(",").map(p => p.trim());
  const deliveryDays = parseInt(wrapper.dataset.days);

  if (pin.length !== 6 || isNaN(pin)) {
    resultBox.style.display = "flex";
    resultText.textContent = "Please enter a valid pincode";
    return;
  }

  if (!pincodes.includes(pin)) {
    resultBox.style.display = "flex";
    resultText.textContent = "Delivery not available at this pincode";
    return;
  }

  const start = new Date();
  start.setDate(start.getDate() + deliveryDays);

  const end = new Date();
  end.setDate(end.getDate() + deliveryDays + 2);

  const options = { day: "numeric", month: "short" };

  resultText.textContent =
    `Delivery between ${start.toLocaleDateString("en-IN", options)} and ${end.toLocaleDateString("en-IN", options)}`;

  resultBox.style.display = "flex";
});
document.addEventListener("keydown", function (e) {
  if (e.key === "Enter" && document.activeElement.classList.contains("delivery-pincode")) {
    document.querySelector(".delivery-check-btn").click();
  }
});
localStorage.setItem("last_pincode", pin);
